import { twMerge } from "tailwind-merge";

interface IStepProps {
    steps: Array<{
        step: number;
        title: string;
        isActive: boolean;
        isCompleted: boolean;
        image: any;
    }>;

}

const VerticalStepper = ({ steps }: IStepProps) => {
    return (
        <div className="flex">
            <div className="w-1/4 p-4">
                <ul className="space-y-4">
                    {steps.map((step, index) => (
                        <li
                            key={step.step}
                            className={`flex  relative text-gray-500 ${step.isCompleted ? "border-primary" : "border-[#9E8F82]"}    ${step.isActive ? 'font-bold text-black' : ''}`}
                        >

                            <div className="flex  items-center">
                                <div
                                    className={twMerge(
                                        "w-0.5 relative -left-[2px] top-[13px] h-10 rounded",
                                        index == steps.length - 1 && "hidden",
                                        step.isActive ? "bg-primary" : "bg-[#9E8F82]",
                                        step.isCompleted ? "bg-primary" : "bg-[#9E8F82]",
                                    )}
                                ></div>
                                <div className="mb-10 ms-6">
                                    <div className={`absolute flex items-center justify-center w-8 h-8 rounded-md -start-4 border border-gray-300`}>
                                        {step.image}
                                    </div>
                                    <div className="flex-1 text-sm">
                                        <div className="flex justify-between items-center gap-x-3 w-full">
                                            <div className="w-[150px]">
                                                <div className="font-medium">STEP {step.step}</div>
                                                <div className="font-medium block text-nowrap">
                                                    {step.title}
                                                </div>
                                            </div>
                                            <div>
                                                {step.isCompleted ? (
                                                    <svg width="20" height="20" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                        <rect x="1" y="1" width="14" height="14" rx="7" fill="#F07F1A" />
                                                        <rect x="1" y="1" width="14" height="14" rx="7" stroke="#F07F1A" strokeWidth="2" />
                                                        <path d="M3.9165 9.1665L5.95817 11.2082L12.0832 4.7915" stroke="white" />
                                                    </svg>
                                                ) : step.isActive ? (
                                                    <div role="status">
                                                        <svg aria-hidden="true" className="w-[20px] h-[20px] text-gray-200 animate-spin fill-primary" viewBox="0 0 100 101" xmlns="http://www.w3.org/2000/svg">
                                                            <path d="M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z" fill="currentColor" />
                                                            <path d="M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z" fill="currentFill" />
                                                        </svg>
                                                    </div>
                                                ) : null}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </li>
                    ))}
                </ul>
            </div>
        </div>
    );
};

export default VerticalStepper;
